"use strict";exports.arrayIncludes=function(t,e,n){if(n){if(n>=t.length)return!1;n<0&&(n=Math.max(0,t.length+n))}return-1!==t.indexOf(e,n)};
//# sourceMappingURL=arrayIncludes.cjs.map
